import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Import your custom CSS for date picker

const CustomDatePicker = () => {
    const [selectedDate, setSelectedDate] = useState(null);

    return (
        <div className="relative flex justify-center items-center w-fit">
            <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                placeholderText="Select Date"
                dateFormat="MMMM d, yyyy"
                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
                calendarClassName="custom-calendar"
                dayClassName={(date) =>
                    date.getDate() === new Date().getDate() ? "bg-purple-100 text-purple-600" : ""
                }
                open={true} // Keeps the date picker always open
                onClickOutside={() => {}} // Prevents it from closing when clicked outside
            />
        </div>
    );
};

export default CustomDatePicker;
